/** Money formatting for the chrome: wire strings in, grouped dollars out. */

/** "48610.1" → "$48,610.10". Falls back to the raw wire on nonsense. */
export function fmtMoney(wire: string | number | null | undefined): string {
  if (wire === null || wire === undefined) return "—";
  const n = Number(wire);
  if (!Number.isFinite(n)) return String(wire);
  return `$${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** Same, but whole dollars — for rates and tight labels. */
export function fmtMoneyRound(wire: string | number | null | undefined): string {
  if (wire === null || wire === undefined) return "—";
  const n = Number(wire);
  if (!Number.isFinite(n)) return String(wire);
  return `$${Math.round(Math.abs(n)).toLocaleString("en-US")}`;
}

/**
 * Buildings still held by the world present as an NPC landlord — a stable
 * fictional person or realty firm derived from the building id. Display only.
 */
const NPC_FIRST = [
  "Otto", "Lena", "Marek", "Ingrid", "Nadia", "Bruno", "Vera", "Casper",
  "Alma", "Ravi", "Sofia", "Henrik", "Mira", "Jonas", "Petra", "Emil",
];
const NPC_LAST = [
  "Patel", "Lindqvist", "Okafor", "Abramson", "Kovacs", "Meunier", "Sato",
  "Novak", "Iversen", "Marino", "Haugen", "Duarte", "Bergman", "Silva",
];
export function npcLandlord(seed: string): string {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  const last = NPC_LAST[(h >>> 12) % NPC_LAST.length]!;
  // Every fourth landlord is a firm, the rest are people.
  if ((h >>> 20) % 4 === 0) return `${last} Realty`;
  return `${NPC_FIRST[(h >>> 4) % NPC_FIRST.length]!} ${last}`;
}
